/**
 * The kind of destination a SmartLink `link` widget points at. Drives which
 * service logo the renderer shows.
 *
 * This is the union of two copies that had drifted apart: fym-common's
 * (which had audiomack/audius but no anghami) and the one sml-preview kept
 * by hand (which had anghami but neither of the other two).
 */
export enum LinkType {
  // -------- GENERIC --------
  generic = 'generic',
  // -------- MUSIC SERVICES --------
  amazonmusic = 'amazonmusic',
  anghami = 'anghami',
  applemusic = 'applemusic',
  deezer = 'deezer',
  pandora = 'pandora',
  soundcloud = 'soundcloud',
  spotify = 'spotify',
  tidal = 'tidal',
  youtube = 'youtube',
  youtubemusic = 'youtubemusic',
  napster = 'napster',
  qobuz = 'qobuz',
  qqmusic = 'qqmusic',
  yandexmusic = 'yandexmusic',
  vkmusic = 'vkmusic',
  zvuk = 'zvuk',
  gaana = 'gaana',
  jiosaavn = 'jiosaavn',
  resso = 'resso',
  boomplay = 'boomplay',
  audiomack = 'audiomack',
  audius = 'audius',
  // -------- OTHER --------
  facebook = 'facebook',
  instagram = 'instagram',
  twitter = 'twitter',
  linkedin = 'linkedin',
  tiktok = 'tiktok',
  reddit = 'reddit',
  snapchat = 'snapchat',
}
